webpackJsonp([255491318291911],{

/***/ 2566:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/step-1.010d73e2.png";

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _step = __webpack_require__(2566);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Add Bootstrap'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to add ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://getbootstrap.com/docs/3.3/' },
	        'Bootstrap 3'
	      ),
	      ', which we\'ll be using to style the application.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'layout.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Install Bootstrap'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To use Bootstrap, we first need to add the necessary CSS and JavaScript files.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'index.html'
	      ),
	      ' file at the root of your project and add the following stylesheet at the bottom of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '<head>'
	      ),
	      ' element.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'html', text: '\n      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css">\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then add these scripts at the bottom of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '<body>'
	      ),
	      ' tag.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'html', text: '\n      <script src="https://code.jquery.com/jquery-2.2.1.min.js"></script>\n      <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"></script>\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Change Page Title'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, locate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '<title>'
	      ),
	      ' tag in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '<head>'
	      ),
	      ' and change it from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'New Lore App'
	      ),
	      ' to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Lore Quickstart'
	      ),
	      ', so that we have a more meaningful title displayed in the browser tab.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'html', text: '\n      <title>Lore Quickstart</title>\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _step2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'index.html'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      <html>\n        <head>\n          <meta charset="utf-8">\n          <meta name="viewport" content="width=device-width, initial-scale=1">\n          <title>Lore Quickstart</title>\n          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css">\n        </head>\n        <body>\n          <div id="loading-screen">\n            <div class="logo breathe"></div>\n          </div>\n          <div id="root"></div>\n          <div id="dialog"></div>\n\n          <script src="https://code.jquery.com/jquery-2.2.1.min.js"></script>\n          <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"></script>\n        </body>\n      </html>\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'add some custom styles'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-layout-step-1-js-3a41bb247a62955f9934.js